import { render, staticRenderFns } from "./assets.vue?vue&type=template&id=4fc925fb&scoped=true&"
import script from "./assets.js?vue&type=script&lang=js&"
export * from "./assets.js?vue&type=script&lang=js&"
import style0 from "./assets.scss?vue&type=style&index=0&id=4fc925fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc925fb",
  null
  
)

export default component.exports